import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function StickyTopBar() {
  return <div className="fixed top-0 left-0 right-0 z-50 bg-safety-red text-white py-2 px-4 shadow-md border-b-2 border-red-900" data-id="element-223">
      <div className="max-w-7xl mx-auto flex items-center justify-center text-center" data-id="element-224">
        <AlertTriangleIcon className="w-4 h-4 mr-2 flex-shrink-0" aria-hidden="true" data-id="element-225" />
        <p className="font-heading font-bold text-sm md:text-base tracking-wide uppercase" data-id="element-226">
          Limited Time: E-Book + 3 Bonuses for $6.39 (Offer ends soon)
        </p>
      </div>
    </div>;
}